import React, { Component } from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup,
    StateStoring,
} from 'devextreme-react/data-grid';
import PaginaToolbar from '../../components/PaginaToolbar';
import {
    criarEntregaNotificacaoDiatDs, criarContribuinteDs,
    criarColaboradorDs, criarTipoNotificacaoDs
} from "../../DataSources";
import UserInfo from "../../UserInfo";
import uiInfo from "../../ui-info";

const localStorageKey = "cadastroEntregaNotificacaoDiatGridState";

let _entregaNotificacaoDiatCorrente = undefined;

export default class EntregaNotificacaoDiatBox extends Component {
    constructor() {
        super();
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("entreganotificaodiat/editar/" + e.data.id);
    }

    render() {

        const statusOptions = [
            { id: "0", descricao: "1 - Gerada" },
            { id: "1", descricao: "2 - Enviada" },
            { id: "2", descricao: "3 - Entregue" },
            { id: "3", descricao: "4 - Não Encontrado" },
            { id: "4", descricao: "5 - Recusado" },
        ];

        const tipoDocumentoOptions = [
            { id: "0", descricao: "Nenhum" },
            { id: "1", descricao: "CNPJ" },
            { id: "2", descricao: "CPF" },
            { id: "2", descricao: "RG" },
            { id: "2", descricao: "Outro" },
        ];

        const escolherStatus = {
            editorType: "dxSelectBox",
            searchEnabled: true,
            dataSource: statusOptions,
            valueExpr: "id",
            displayExpr: "descricao"
        }

        const escolherTipoDocumento = {
            editorType: "dxSelectBox",
            searchEnabled: true,
            dataSource: tipoDocumentoOptions,
            valueExpr: "id",
            displayExpr: "descricao"
        }

        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Entrega Notificação da Dìvida Ativa" novoCb={this.novaEntregaNotificacaoDiat.bind(this)} >
                    <DataGrid
                        ref={grid => this._gridInstance = grid}
                        dataSource={criarEntregaNotificacaoDiatDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        columnAutoWidth={true}
                        columnHidingEnabled={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={window.innerWidth < 800}
                        filterSyncEnabled={true}
                        onEditingStart={this.onAtualizandoRow}>
                        <StateStoring enabled={true} type={'localStorage'} storageKey={localStorageKey} />
                        <FilterRow visible={true} />
                        <Editing allowAdding={false} allowDeleting={true} allowUpdating={true} mode />
                        <Column dataField={'id'} caption={"#"} alignment={'center'} />
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'numero'} caption={"Número"} />
                        <Column dataField={'ano'} caption={"Ano"} />
                        <Column dataField={'emissao'} caption={"Data de Emissão"} />
                        <Column dataField={'contribuinteId'} caption={"Contribuinte"}>
                            <Lookup
                                dataSource={criarContribuinteDs}
                                valueExpr={"id"}
                                displayExpr={"nome"} />
                        </Column>
                        <Column dataField={'tipoId'} caption={"Tipo de Notificação"}>
                            <Lookup
                                dataSource={criarTipoNotificacaoDs}
                                valueExpr={"id"}
                                displayExpr={"texto"} />
                        </Column>
                        <Column dataField={'enviadoEm'} caption={"Data de Envio"} />
                        <Column dataField={'lote'} caption={"Lote"} />
                        <Column dataField={'codigoDeBarras'} caption={"Código de Barras"} />
                        <Column dataField={'status'} caption={"Status da Notificação"}>
                            <Lookup
                                dataSource={escolherStatus}
                                valueExpr={"id"}
                                displayExpr={"descricao"} />
                        </Column>
                        <Column dataField={'entregueEm'} caption={"Data de Entrega"} />
                        <Column dataField={'nomeRecebedor'} caption={"Nome do Recebedor"} />
                        <Column dataField={'tipoDeDocumento'} caption={"Tipo de Documento"}>
                            <Lookup
                                dataSource={escolherTipoDocumento}
                                valueExpr={"id"}
                                displayExpr={"descricao"} />
                        </Column>
                        <Column dataField={'documento'} caption={"Documento"} />
                        <Column dataField={'orgaoEmissor'} caption={"Órgão Emissor"} />
                        <Column dataField={'entregador'} caption={"Entregador"}>
                            <Lookup
                                dataSource={criarColaboradorDs}
                                valueExpr={"id"}
                                displayExpr={"nome"} />
                        </Column>
                        <Column dataField={'testemunha1'} caption={"Primeira Testemunha"} />
                        <Column dataField={'testemunha2'} caption={"Segunda Testemunha"} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    novaEntregaNotificacaoDiat() {
    }

}
